var style = document.createElement("style");
style.setAttribute("less", "svg-map.less");
style.innerHTML = "svg-map {\n  position: relative;\n}\nsvg-map svg {\n  width: 100%;\n  display: block;\n}\nsvg-map .popup {\n  position: absolute;\n  padding: 8px;\n  display: none;\n  z-index: 999;\n}\nsvg-map .popup[show] {\n  display: block;\n}\n";
document.head.appendChild(style);
